import { render, staticRenderFns } from "./GanttProjetos.vue?vue&type=template&id=76519d82&scoped=true&"
import script from "./GanttProjetos.vue?vue&type=script&lang=js&"
export * from "./GanttProjetos.vue?vue&type=script&lang=js&"
import style0 from "./GanttProjetos.vue?vue&type=style&index=0&id=76519d82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76519d82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
